import { forwardRef, LegacyRef } from 'react';
import { Link } from 'react-router-dom';
import ManagementDecorator from '../../pages/management/ManagementDecorator';

function DataSources(_: object, ref: LegacyRef<HTMLDivElement>): JSX.Element {
  return ManagementDecorator(ref, () => (
    <div className="uk-container uk-text-center uk-margin-large-top">
      <div className="uk-card uk-card-default disabled">
        <div className="card-content">
          <h3>Manuelle</h3>
          <p>Dédinition des sources de données</p>
        </div>
        <span className="arrow-icon" uk-icon="arrow-right"></span>
      </div>
      <Link
        to="/management/manual"
        className="uk-card uk-card-default"
        style={{ textDecoration: 'none' }}
      >
        <div className="card-content">
          <h3>Automatique</h3>
          <p>Récuperation automatique des données</p>
        </div>
        <span className="arrow-icon" uk-icon="arrow-right"></span>
      </Link>
      <div className="uk-card uk-card-default disabled">
        <div className="card-content">
          <h3>Semi automatique</h3>
          <p>Récuperation à partir d'un fichier excel</p>
        </div>
        <span className="arrow-icon" uk-icon="arrow-right"></span>
      </div>
    </div>
  ));
}

export default forwardRef(DataSources);
